// Lightweight WebSocket client used by Messages + Rooms.
// Auto-reconnects with backoff. Falls back gracefully: if it fails to open,
// the caller's existing polling continues to work.

import { BACKEND_URL } from "@/lib/api";

const wsBase = () => {
  try {
    const u = new URL(BACKEND_URL);
    u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
    return `${u.origin}/api/ws`;
  } catch {
    return "/api/ws";
  }
};

export function openWS(path, onMessage, { token, onOpen, onClose } = {}) {
  let ws = null;
  let closedByUser = false;
  let retry = 0;
  let pingTimer = null;

  const connect = () => {
    const tokenQs = token ? `?token=${encodeURIComponent(token)}` : "";
    const url = `${wsBase()}${path}${tokenQs}`;
    try {
      ws = new WebSocket(url);
    } catch {
      return;
    }
    ws.onopen = () => {
      retry = 0;
      onOpen?.();
      // Keep-alive ping every 25s
      pingTimer = setInterval(() => { try { ws.send("ping"); } catch {} }, 25000);
    };
    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        onMessage?.(data);
      } catch {}
    };
    ws.onclose = () => {
      clearInterval(pingTimer);
      onClose?.();
      if (closedByUser) return;
      retry = Math.min(retry + 1, 5);
      setTimeout(connect, 1000 * retry); // 1s, 2s, 3s, 4s, 5s
    };
    ws.onerror = () => { try { ws.close(); } catch {} };
  };

  connect();

  return {
    close: () => {
      closedByUser = true;
      clearInterval(pingTimer);
      try { ws?.close(); } catch {}
    },
  };
}
